import axios from "axios";


export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const IMAGES = {
  mascot: "/img/mascot.webp",
  mascotSmall: "/img/mascot-400.webp",
  bottle: "/img/bottle.webp",
  multi: "/img/multi.webp",
  bundle: "/img/bundle.webp",
  surf: "https://images.unsplash.com/photo-1526342256246-b67e94be5c79?crop=entropy&cs=srgb&fm=webp&q=80&w=1600",
  surfGold: "https://images.unsplash.com/photo-1509914398892-963f53e6e2f1?crop=entropy&cs=srgb&fm=webp&q=80&w=800",
  surfGold2x: "https://images.unsplash.com/photo-1509914398892-963f53e6e2f1?crop=entropy&cs=srgb&fm=webp&q=80&w=1600",
};

export const CURRENCY = "USD";
export const money = (n) => `US$${Number(n || 0).toFixed(2)}`;
export const priceLine = (p) => `${money(p.price_usd)} · ${p.count} ${p.unit}`;
export const shipCost = (country, lb) => {
  lb = Math.round(lb * 1e6) / 1e6;
  if (country === "US") return lb <= 3 ? 15 : Math.round((15 + 2.95 * Math.ceil(lb - 3)) * 100) / 100;
  const [tiers, extra] = ZONE_RATES[SHIP_ZONES[country]] || ZONE_RATES.Z3;
  for (let i = 0; i < 4; i += 1) if (lb <= i + 1) return tiers[i];
  return Math.round((tiers[3] + extra * Math.ceil(lb - 4)) * 100) / 100;
};
export const shipFeeLines = (country = "US", lines = []) => shipCost(country, lines.reduce((s, [p, q]) => s + Number(p?.shipping_weight_oz || 17.6) * q, 0) / 16);
export const shipFee = (country = "US", prods = []) => shipFeeLines(country, prods.map((p) => [p, 1]));
// UK and ID PH TH VN KR MO held back for now
export const SHIP_ZONES = { US: "US", CA: "Z1", BE: "Z2", DK: "Z2", FI: "Z2", FR: "Z2", IS: "Z2", IT: "Z2", LI: "Z2", LU: "Z2", MT: "Z2", MC: "Z2", NL: "Z2", NO: "Z2", PT: "Z2", SE: "Z2", AU: "Z3", BG: "Z3", HR: "Z3", CY: "Z3", CZ: "Z3", EE: "Z3", HU: "Z3", LV: "Z3", LT: "Z3", NZ: "Z3", PL: "Z3", RO: "Z3", SK: "Z3", SI: "Z3" };
const ZONE_RATES = { Z1: [[19.95, 20.95, 22.95, 24.95], 5.95], Z2: [[20.95, 21.95, 24.95, 27.95], 6.95], Z3: [[25.95, 27.95, 33.95, 38.95], 8.95] };
const ZONE_LABELS = { Z1: "Canada shipping", Z2: "Europe shipping", Z3: "International shipping" };
export const SHORT_NAMES = { ...{ US: "United States", CA: "Canada", BE: "Belgium", DK: "Denmark", FI: "Finland", FR: "France", IS: "Iceland", IT: "Italy", LI: "Liechtenstein", LU: "Luxembourg", MT: "Malta", MC: "Monaco", NL: "Netherlands", NO: "Norway", PT: "Portugal", SE: "Sweden", AU: "Australia", BG: "Bulgaria", HR: "Croatia", CY: "Cyprus", CZ: "Czech Republic", EE: "Estonia", HU: "Hungary", LV: "Latvia", LT: "Lithuania", NZ: "New Zealand", PL: "Poland", RO: "Romania", SK: "Slovakia", SI: "Slovenia" }, US: "US" };
export const COUNTRY_NAMES = { ...SHORT_NAMES, US: "the United States" };
export const ZONE_SAMPLES = [["US", "US"], ["CA", "Canada"], ["FR", "Europe"], ["AU", "Australia, NZ & Eastern Europe"]];
export const shipLabel = (country = "US") => (country === "US" ? "US Standard shipping" : ZONE_LABELS[SHIP_ZONES[country]] || "Shipping");
export const canShip = (settings, c) => !!settings && (settings.ship_countries || []).includes(c) && !!SHIP_ZONES[c];
const ORDER = ["US"];
export const shipCountries = (settings) => (settings?.ship_countries || []).filter((c) => canShip(settings, c))
  .sort((a, b) => ((ORDER.indexOf(a) + 1) || 99) - ((ORDER.indexOf(b) + 1) || 99) || SHORT_NAMES[a].localeCompare(SHORT_NAMES[b]));
export const subPrice = (p) => Number(p.sub_price_usd ?? Math.round(p.price_usd * 85) / 100);
export const subPct = (p) => Math.round((1 - subPrice(p) / p.price_usd) * 100);
export const memberPrice = (p) => Number(p.member_price_usd ?? p.price_usd);
export const curCtx = (prods = []) => ({ us: money(shipFee("US", prods)), intl: money(shipFee("CA", prods)), processor: "Stripe" });
const IMG_VERSION = { "bone-k2": "ab", "bone-and-heart": "ab", moringa: "ab" };
export const productImage = (id, w) => `/products/${w ? `${w}/` : ""}${id}.webp${IMG_VERSION[id] ? `?v=${IMG_VERSION[id]}` : ""}`;
export const productSrcSet = (id) => `${productImage(id, 400)} 400w, ${productImage(id, 800)} 800w`;

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return fallback;
};
